



















import Vue from "vue";
import { InstallationPredictedStatusEnum, installationPredictedStatusEnumLabel } from "@/model/data/predictiveMaintenance/InstallationPredictedStatusEnum";

export default Vue.extend({
    data() {
        return {
            // InstallationStatusEnum,
            selection: [],
        };
    },
    computed: {
        availableData() {
            return Object.values(InstallationPredictedStatusEnum).filter((x) => !isNaN(parseInt(x.toString())));
        },
    },
    watch: {
        selection() {
            this.$emit("input", this.selection);
        },
    },
    methods: {
        installationPredictedStatusEnumLabel,
    },
});
